<template>
  <svg
    viewBox="3 2 18 20.25"
    xmlns="http://www.w3.org/2000/svg"
    class="radius-icon"
  >
    <line
      x1="21"
      y1="12"
      x2="12"
      y2="12"
    />
    <circle
      cx="12"
      cy="12"
      r="9"
    />
  </svg>
</template>

<script>
export default {
  name: 'RadiusIcon',
};
</script>

<style lang="scss" scoped>
.radius-icon > * {
  fill: none;
  stroke: main.$npGray;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}
.radius-icon.selected > * {
  stroke: #fff;
}
</style>
